/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { paragraphXSmall } from 'src/components/css'

interface Props {
  icon: React.ReactNode
  label: string
  /** Secondary line — one step dimmer than the stats above it. */
  muted?: boolean
}

/** One icon + label fact in a team-history line; truncates rather than wraps. */
const HistoryMetaItem = ({ icon, label, muted = false }: Props) => (
  <span css={[itemStyle, muted && mutedStyle]}>
    <span css={iconStyle} aria-hidden='true'>
      {icon}
    </span>
    <span css={labelStyle}>{label}</span>
  </span>
)

export default HistoryMetaItem

const itemStyle = css`
  ${paragraphXSmall}
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  color: ${colors.NEUTRAL_50};
`

const mutedStyle = css`
  color: ${colors.NEUTRAL_80};
`

/* Sized to the 12px label it sits beside. */
const iconStyle = css`
  display: inline-flex;
  flex-shrink: 0;
  font-size: 12px;
`

const labelStyle = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
